import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2ComputerOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path d="M18 20.65v-2h-4v2zm9-.444v-3H5v5h24v.019l-1.387 1.981H20v2h3v2H9v-2h3v-2H3v-20h26v16zm-13 6h4v-2h-4zm13-11v-9H5v9z" /></svg>
);
